import { useCallback, useState } from 'react';

export function useToast() {
  const [toasts, setToasts] = useState([]);

  const pushToast = useCallback((message, tone = 'info') => {
    setToasts((prev) => {
      if (prev.some((toast) => toast.message === message)) {
        return prev;
      }
      const id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
      const next = [...prev, { id, message, tone }];
      setTimeout(() => {
        setToasts((current) => current.filter((toast) => toast.id !== id));
      }, 3600);
      return next;
    });
  }, []);

  return { toasts, pushToast };
}
